export default __webpack_public_path__ + "static/media/4.d7830e43.png";